import AppBanner from '~/components/app-banner/app-banner-async.js';

const RoutesAppBanner = () => <AppBanner startWithoutAnimation />;
export default RoutesAppBanner;
